// source/assets/blog.js
var BlogFilter = class extends HTMLElement {
  constructor() {
    super();
    const filter = document.querySelector("select");
    filter.addEventListener("change", function() {
      window.location.href = filter.value;
    });
  }
};
customElements.define("blog-filter", BlogFilter);
//# sourceMappingURL=blog.js.map
